import { memo, ReactElement } from 'react';
import { FilterPanelHeaderLayout } from './FilterPanelLayout';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import TuneIcon from '@mui/icons-material/Tune';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

export interface FilterPanelHeaderProps {
  onClose?: () => unknown;
}

export const FilterPanelHeader = memo(function ({ onClose }: FilterPanelHeaderProps): ReactElement {
  const { t } = useTranslation();
  return (
    <FilterPanelHeaderLayout>
      <Typography variant='h6' gutterBottom sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
        <TuneIcon sx={{ mr: 1 }} />
        {t('filter.title')}
      </Typography>
      {!!onClose && (
        <IconButton
          sx={{
            display: { xs: 'block', sm: 'block', md: 'none' },
            ml: 'auto',
            mr: 2,
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      )}
    </FilterPanelHeaderLayout>
  );
});
